'use strict';

const { Router } = require('dibs-backbone');
const GalleryStore = require('../gallery/stores/GalleryStore');
const galleryActions = require('./actions/galleryActions');

const GalleryRouter = Router.extend({
    stores: [GalleryStore],

    routes: {
        'photo/:urlLabel/:id(/)': '_setPhoto',
        '*splat': 'refresh',
    },

    initialize(options) {
        this._updatePropsAndNavigate = this._updatePropsAndNavigate.bind(this);

        this.context = options.context;
        this._contextStores = [];

        this.stores.forEach(store => {
            this._contextStores.push(this.context.getStore(store));
            this.context.getStore(store).addChangeListener(this._updatePropsAndNavigate);
        });
    },

    _updatePropsAndNavigate() {
        this.props = this.getPropsFromStores.apply(this, this._contextStores);
        this.update();
    },

    /**
     *
     */
    getPropsFromStores(galleryStore) {
        return { route: galleryStore.getCurrentPhotoUrl() };
    },

    /**
     * Update function called each time the galleryStore emits a change
     *  - Changes the url
     */
    update() {
        if (this.props.route) {
            // Note: this will NOT also call the route method
            this.navigate(this.props.route);
        }
    },

    /**
     * Route Handler - executes action to set photo
     *  (invoked mostly when the user hits the back button)
     */
    _setPhoto(urlLabel, rootId) {
        const galleryStore = this.context.getStore(GalleryStore);
        const url = galleryStore.buildPhotoUrl({ urlLabel, rootId });

        if (url && typeof galleryStore.getPhotoByUrl(url) !== 'undefined') {
            // If Photo url exists, set url
            this.context.executeAction(galleryActions.setPhoto, { url });
        } else {
            // Else refresh b/c navigating to photo URL outside of current gallery
            this.refresh();
        }
    },

    /**
     * Trigger page refresh
     */
    refresh() {
        location.reload();
    },
});

module.exports = GalleryRouter;



// WEBPACK FOOTER //
// ./assets/js/gallery/GalleryRouter.es.js